import { i18n } from "@/plugins/i18n"

/**
 * Generates the footer for a route PDF.
 *
 * @returns {HTMLDivElement} - The generated footer as a HTML div element.
 */
export default function generateRoutePdfFooter() {
  const footer = document.createElement('div')
  footer.classList.add('route-pdf-footer')

  const dateEl = document.createElement('p')
  const date = new Date()
  dateEl.innerText =  `${ date.getDate() } ${ date.toLocaleString('default', {month: 'short'}) } ${ date.getFullYear() }`

  const signatureEl = document.createElement('p')
  signatureEl.innerText = i18n.t('routePDF.footerCopyright')
  signatureEl.classList.add('route-pdf-footer__signature')

  footer.appendChild(dateEl)
  footer.appendChild(signatureEl)

  footer.style.fontFamily = 'sans-serif'

  return footer
}